import { useState } from 'react'
import { useCustomer } from '../../Providers/CustomerProvider'
import { useAuth } from '../../Providers/AuthProvider'
import { ConvertPriceToString } from '../../Helpers/CustomConverter'
import ZipCodeInputModal from '../Components/Modals/ZipCodeInputModal'
import { useWarehouse } from '../../Providers/WarehouseProvider'
import useWarehouseOperations from '../../Hooks/useWarehouseOperations'

const CustomerInformation = () => {
    const { authState } = useAuth()
    const { creditInfo } = useCustomer()
    const { warehouses, handleChangeWarehouse } = useWarehouse()
    const [showWarehouses, setShowWarehouses] = useState(false)
    const [showZipCodeInput, setShowZipCodeInput] = useState(false)
    const { findSelectedWarehouseName } = useWarehouseOperations()

    const handleChangeWarehouseFunc = (warehouse) => {
        handleChangeWarehouse(warehouse)
        setShowWarehouses(false)
    }

    const handleZipCodeInput = (res) => {
        setShowZipCodeInput(false)
    }

    const customerInformationPhModeStyle = authState.user && authState.user.isOperator ? '' : 'hidden'
    const customerInformationSiteInfoStyle = authState.siteId && authState.user ? '' : 'hidden'

    const generateWarehouseSelector = () => {
        if (authState.user && authState.siteId) {
            return (<div className={`${customerInformationSiteInfoStyle} ms-3 d-inline-block position-relative element-pointer`} onMouseEnter={() => setShowWarehouses(true)} onMouseLeave={() => setShowWarehouses(false)}>
                <span className="secondary-color-text">{(findSelectedWarehouseName(authState.whId))}</span>
                {showWarehouses && (
                    <div className="customer-information-site-selector position-absolute">
                        <div className="row">
                            {warehouses.length > 0 && warehouses.map((item, key) => (
                                <div key={key} className="col-12 mb-2 customer-information-site-selector-item" onClick={() => handleChangeWarehouseFunc(item)}>
                                    <b className='me-2'>{`${item.name}`}</b>
                                    <span>{item.whAddress}</span>
                                </div>
                            ))}
                        </div>
                    </div>
                )}
            </div>)
        }
        else {
            const wareHouseText = !authState.whId ? 'Zlokalizuj magazyn' : findSelectedWarehouseName(authState.whId)
            return (<div className='ms-3 d-inline-block element-pointer'>
                <span className='secondary-color-text' onClick={() => setShowZipCodeInput(true)}>{wareHouseText}</span>
            </div>)
        }
    }

    return (
        <>
            <ZipCodeInputModal
                show={showZipCodeInput}
                onHide={handleZipCodeInput}
            />
            <div className={`col text-end`}>
                <b className={`${customerInformationPhModeStyle} secondary-color-text`}>{`Tryb PH`}</b>
                {generateWarehouseSelector()}
                <span className={`${customerInformationSiteInfoStyle} secondary-color-text ms-3`}>{`Limit kredytowy: ${ConvertPriceToString(creditInfo.remainCredit)} / ${ConvertPriceToString(creditInfo.grantCredit)}`}</span>
            </div>
            <div className="col-1"></div>
        </>
    )
}

export default CustomerInformation